/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinflyerheadlinequeue3Inputs */

const en_checkinflyerheadlinequeue3 = /** @type {(inputs: Checkinflyerheadlinequeue3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Still in the queue?`)
};

const de_checkinflyerheadlinequeue3 = /** @type {(inputs: Checkinflyerheadlinequeue3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch in der Schlange?`)
};

/**
* | output |
* | --- |
* | "Still in the queue?" |
*
* @param {Checkinflyerheadlinequeue3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinflyerheadlinequeue3 = /** @type {((inputs?: Checkinflyerheadlinequeue3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinflyerheadlinequeue3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinflyerheadlinequeue3(inputs)
	return de_checkinflyerheadlinequeue3(inputs)
});
export { checkinflyerheadlinequeue3 as "checkinFlyerHeadlineQueue" }